let state = {
  activeTransaction: undefined,
  settledTransactions: [],
  settledTxnError:{
    status:false,
    message:"Something went wrong! Please try again later."
  }
}
export default state



// WEBPACK FOOTER //
// ./src/store/transaction/state.js